import { Seo, breadcrumbLd } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { RichText } from "@/components/site/RichText";
import { useSettings } from "@/lib/api";

export default function Legal({ kind }) {
  const s = useSettings();
  const isPrivacy = kind === "privacy";
  const title = isPrivacy ? "Privacy Policy" : "Cookie Policy";
  const path = isPrivacy ? "/privacy-policy" : "/cookie-policy";
  const crumbs = [["Home", "/"], [title, path]];
  return (
    <>
      <Seo title={title} path={path} description={`${title} for Digital AdDoctor, Tunbridge Wells, Kent.`} jsonLd={[breadcrumbLd(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Legal" lines={[title]} />
      <section className="bg-white py-20" data-testid={`legal-${kind}`}>
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <RichText text={isPrivacy ? s.privacy_policy : s.cookie_policy} />
          {!isPrivacy && (
            <button onClick={() => window.dispatchEvent(new Event("dad-open-consent"))} className="btn-primary mt-6" data-testid="legal-cookie-settings">Change cookie settings</button>
          )}
        </div>
      </section>
    </>
  );
}
